export const genericMessages = {
  pt: {
    message: {
      accesses: "Acessos",
      add: "Adicionar",
      admin: "Admin",
      advance: "Avançar",
      advancedSettings: "Configurações Avançadas",
      amount: "Quantidade",
      changeAvatar: "Alterar avatar",
      changeLanguage: "Alterar idioma",
      confirm: "Confirmar",
      confirmExclusion: "Confirma a exclusão?",
      copy: "Copiar",
      cancel: "Cancelar",
      clear: "Limpar",
      creationDate: "Data de criação",
      custom: "Personalizado",
      delete: "Deletar",
      description: "Descrição",
      draft: "Rascunho",
      duplicate: "Duplicar",
      edit: "Editar",
      endDate: "Data de Término",
      english: "Inglês",
      exclude: "Excluir",
      excludeClient: "Excluir cliente",
      excludeTag: "Excluir Tag",
      exportCsv: "Exportar arquivo CSV",
      fetchData: "Buscar dados",
      fifteenDays: "15 dias",
      funcionalityNotActive:
        "Esta funcionalidade não está ativa para sua conta, para ativá-la entre em contato com nossa equipe",
      general: "Geral",
      generalData: "Dados Gerais",
      gridView: "Visão em grid",
      ip: "IP",
      email: "E-mail",
      logout: "Sair",
      masterUser: "Usuário Master",
      max: "Número máximo",
      metaDescription:
        "O sistema de captive portal Wi-Fi do WiFeed é um produto de autenticação e gestão do Wi-Fi para provedores, operadoras e estabelecimentos.",
      min: "Número mínimo",
      name: "Nome",
      noData: "Sem dados",
      noResultsFound: "Nenhum resultado encontrado",
      notInformed: "Não informado",
      oneMonth: "1 mês",
      operation: "Operação",
      period: "Período",
      phoneNumber: "Telefone",
      portuguese: "Português",
      register: "Cadastrar",
      remove: "Remover",
      identifier: "CPF/CNPJ",
      save: "Salvar",
      search: "Pesquisar...",
      settings: "Configurações",
      sixMonths: "6 meses",
      sms: "SMS",
      spanish: "Espanhol",
      spots: "Locais",
      submit: "Pronto",
      startDate: "Data de Início",
      status: "Status",
      tableView: "Visão em tabela",
      test: "Testar",
      threeMonths: "3 meses",
      totalRecords: "Total de registros",
      userName: "Nome do Usuário",
      users: "Usuários",
      view: "Visualizar",
      noOptionsText: "Nenhuma opção disponível",
      yes: "Sim",
      no: "Não",
      comingSoon: "Em Breve",
      change: "Alterar",
      domainConfig: "Configurações de domínio",
      domain: "Domínio",
      create: "Criar",
      role: 'Cargo'
    },
  },
  es: {
    message: {
      accesses: "Accessos",
      add: "Agregar",
      admin: "Admin",
      advance: "Avance",
      advancedSettings: "Configuraciones avanzadas",
      amount: "Cantidad",
      changeAvatar: "Cambiar avatar",
      changeLanguage: "Cambia el idioma",
      confirm: "Confirmar",
      confirmExclusion: "¿Confirma la exclusión?",
      copy: "Copiar",
      cancel: "Cancelar",
      clear: "Limpiar",
      creationDate: "Fecha de creación",
      custom: "Personalizado",
      delete: "Borrar",
      description: "Descripción",
      draft: "Borrador",
      duplicate: "Duplicar",
      edit: "Editar",
      endDate: "Fecha de finalización",
      english: "Inglés",
      exclude: "Borrar",
      excludeClient: "Eliminar cliente",
      excludeTag: "Eliminar etiqueta",
      exportCsv: "Exportar archivo CSV",
      fetchData: "Buscar datos",
      fifteenDays: "15 días",
      funcionalityNotActive:
        "Esta funcionalidad no está activa para su cuenta, para activarla comuníquese con nuestro equipo",
      general: "General",
      generalData: "Datos generales",
      gridView: "Visión de grilla",
      ip: "IP",
      email: "Correo electrónico",
      logout: "Salir",
      masterUser: "Usuario maestro",
      max: "Número máximo",
      metaDescription:
        "El sistema de portal cautivo Wi-Fi de WiFieed es un producto de gestión y autenticación Wi-Fi para proveedores, operadores y establecimientos.",
      min: "Número mínimo",
      name: "Nombre",
      noData: "Sin datos",
      noResultsFound: "Ningún resultado encontrado",
      notInformed: "No informado",
      oneMonth: "1 mes",
      operation: "Operación",
      period: "Período",
      phoneNumber: "Teléfono",
      portuguese: "Portugués",
      register: "Registrar",
      remove: "Remover",
      identifier: "RUC/CI",
      save: "Guardar",
      search: "Buscar...",
      settings: "Configuraciones",
      sixMonths: "6 meses",
      sms: "SMS",
      spanish: "Español",
      spots: "Locales",
      submit: "Listo",
      startDate: "Fecha de inicio",
      status: "Estado",
      tableView: "Visión de tabla",
      test: "Prueba",
      threeMonths: "3 meses",
      totalRecords: "Registros totales",
      userName: "Nombre de usuario",
      users: "Usuarios",
      view: "Visualizar",
      noOptionsText: "No hay opción disponible",
      yes: "Si",
      no: "No",
      comingSoon: "Pronto",
      change: "Cambio",
      domainConfig: "Configuración del dominio",
      domain: "Dominio",
      create: "Crear",
      role: 'Cargo'
    },
  },
  en: {
    message: {
      accesses: "Accesses",
      add: "Add",
      admin: "Admin",
      advance: "Advance",
      advancedSettings: "Advanced Settings",
      amount: "Amount",
      changeAvatar: "Change avatar",
      changeLanguage: "Change language",
      confirm: "Confirm",
      confirmExclusion: "Confirm exclusion?",
      copy: "Copy",
      cancel: "Cancel",
      clear: "Clear",
      creationDate: "Creation date",
      custom: "Custom",
      delete: "Delete",
      description: "Description",
      draft: "Draft",
      duplicate: "Duplicate",
      edit: "Edit",
      endDate: "End date",
      english: "English",
      exclude: "Remove",
      excludeClient: "Exclude client",
      excludeTag: "Exclude Tag",
      exportCsv: "Export CSV file",
      fetchData: "Fetch data",
      fifteenDays: "15 days",
      funcionalityNotActive:
        "This functionality is not active for your account, to activate it please contact our team",
      general: "General",
      generalData: "General data",
      gridView: "Grid view",
      ip: "IP",
      email: "Email",
      logout: "Logout",
      masterUser: "Master user",
      max: "Maximum number",
      metaDescription:
        "WiFeed's Wi-Fi captive portal system is a Wi-Fi authentication and management product for providers, operators and establishments.O sistema de captive portal Wi-Fi do WiFeed é um produto de autenticação e gestão do Wi-Fi para provedores, operadoras e estabelecimentos.",
      min: "Minimum number",
      name: "Name",
      noData: "No data",
      noResultsFound: "No results found",
      notInformed: "Not informed",
      oneMonth: "1 month",
      operation: "Operation",
      period: "Period",
      phoneNumber: "Phone",
      portuguese: "Portuguese",
      register: "Register",
      remove: "Remove",
      identifier: "CPF/CNPJ",
      save: "Save",
      search: "Search...",
      settings: "Settings",
      sixMonths: "6 months",
      sms: "SMS",
      spanish: "Spanish",
      spots: "Spots",
      submit: "Submit",
      startDate: "Start date",
      status: "Status",
      tableView: "Table view",
      test: "Test",
      threeMonths: "3 months",
      totalRecords: "Total records",
      userName: "Username",
      users: "Users",
      view: "View",
      noOptionsText: "No available options",
      yes: "Yes",
      no: "No",
      comingSoon: "Coming soon",
      change: "Change",
      domainConfig: "Domain Configuration",
      domain: "Domain",
      create: "Create",
      role: 'Role'
    },
  },
};
